import filters from "@/filters/filter";
import CONSTANTS from "@/store/constants";
import EXCEPTION_SUBMISSION_CONSTANTS from "@/store/exceptionSubmissionRequestFormConstants";


const VGT_COLUMNS = {
    parseInvoiceAmount(value) {
        return parseFloat(filters.ehTruncateHTML(value, 20).replace(/,/g, '').slice(4))
    },
    sortCopyAction(x, y, rowX, rowY) {
        let formattedX = this.isCopyEligible(x, rowX.channelId) ? 'Copy' : 'N/A'
        let formattedY = this.isCopyEligible(y, rowY.channelId) ? 'Copy' : 'N/A'
        return (formattedX < formattedY ? -1 : (formattedX > formattedY ? 1 : 0));
    },
    isCopyEligible(invoice, channelId) {
        return (invoice === CONSTANTS.PO_BASED_API_FORM_TYPE || invoice === CONSTANTS.NON_PO_BASED_API_FORM_TYPE) && channelId && channelId === CONSTANTS.ALLOWED_CHANNEL_FOR_COPY
    },
    clearHTMLAndFilter(x, y) {
        let formattedX = filters.ehTruncateHTML(x, 20)
        let formattedY = filters.ehTruncateHTML(y, 20)
        return (formattedX < formattedY ? -1 : (formattedX > formattedY ? 1 : 0));
    },
    clearHTMLandCurrency(x, y) {
        let formattedX = parseFloat(filters.ehTruncateHTML(x, 20).replace(/\D/g, ''))
        let formattedY = parseFloat(filters.ehTruncateHTML(y, 20).replace(/\D/g, ''))
        return (formattedX < formattedY ? -1 : (formattedX > formattedY ? 1 : 0));
    },
    sortAttachmentFileNames(x,y){
        //This function picks up the 1st element of the attachment if it's an array in case multiple attachments are present in a record.
        let formattedX  = x && x.length > 0 ? x[0] : x;
        let formattedY = y && y.length > 0 ? y[0] : y;
        return (formattedX < formattedY ? -1 : (formattedX > formattedY ? 1 : 0));
    },
    INVOICES_TABLE_COLUMNS: [
        {
            label: "Supplier name",
            field: "supplierName",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left text-wrap hide-field-xs",
            width: "16%",
            sortable: true
        },
        {
            label: "Invoice number",
            field: "invoiceNumber",
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left",
            width: "11%"
        },
        {
            label: "Purchase order number",
            field: "poNumber",
            type: "string",
            thClass: "width-sm  hide-field-md",
            tdClass: "align-left text-break  hide-field-md",
            width: "10%",
            sortable: true
        },
        {
            label: "Invoice amount",
            type: "string",
            field: "invoiceAmount",
            sortFn: (x, y) => {
                let formattedAmountX = VGT_COLUMNS.parseInvoiceAmount(x)
                let formattedAmountY = VGT_COLUMNS.parseInvoiceAmount(y)
                return (formattedAmountX < formattedAmountY ? -1 : (formattedAmountX > formattedAmountY ? 1 : 0));
            },
            thClass: "width-sm",
            tdClass: "align-left wrap-text",
            width: "12%",
            html: true
        },
        {
            label: "Invoice date",
            field: "invoiceDate",
            type: "string",
            thClass: "width-sm hide-field-lg",
            tdClass: "align-left hide-field-lg",
            width: "10%"
        },
        {
            label: "Payment due date",
            field: "paymentDueDate",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "13%"
        },
        {
            label: "Invoice status",
            field: "formattedInvoiceStatus",
            sortFn: (x, y) => {
                return VGT_COLUMNS.clearHTMLAndFilter(x, y)
            },
            type: "string",
            thClass: "width-sm hide-field-md",
            tdClass: "align-left hide-field-md table-data-ellipsis",
            width: "8%",
            html: true
        },
        {
            label: "Action",
            field: "docType",
            sortFn: (x, y, col, rowX, rowY) => {
                return VGT_COLUMNS.sortCopyAction(x, y, rowX, rowY)
            },
            type: "string",
            thClass: "width-sm text-right",
            tdClass: "text-right",
            width: "9%",
            sortable: true
        }
    ],
    PURCHASE_ORDER_TABLE_COLUMNS: [
        {
            label: "Supplier name",
            field: "supplierName",
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left text-wrap",
            width: "23%",
            sortable: true
        },
        {
            label: "Purchase order number",
            field: "poNumber",
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left",
            width: "18%",
            sortable: true
        },
        {
            label: "Purchase order date",
            field: "docDate",
            type: "string",
            thClass: "width-sm hide-field-md",
            tdClass: "align-left hide-field-md",
            width: "16%",
            sortable: true
        },
        {
            label: "Purchase order amount (USD)",
            field: "purchaseOrderAmountinUSD",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "18%",
            sortable: true,
            sortFn: (x, y) => {
                return VGT_COLUMNS.clearHTMLandCurrency(x, y)
            },
            html: true
        },
        {
            label: "Purchase order amount",
            field: "purchaseOrderAmount",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "16%",
            sortable: true,
            sortFn: (x, y) => {
                return VGT_COLUMNS.clearHTMLandCurrency(x, y)
            },
            html: true
        },
        {
            label: "Status",
            field: "status",
            sortFn: (x, y) => {
                return VGT_COLUMNS.clearHTMLAndFilter(x, y)
            },
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "11%",
            sortable: true,
            html: true
        },
        {
            label: "Requested by",
            field: "requestedByFullName",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "12%",
            sortable: false
        }
    ],
    INVOICES_DRAFTS_COLUMNS: [
        {
            label: "Supplier name",
            field(rowObj) {
                return rowObj.supplierNameContinued ? rowObj.supplierName + rowObj.supplierNameContinued : rowObj.supplierName
            },
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left",
            width: "23%"
        },
        {
            label: "Purchase order number",
            field: "poNumber",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left text-break hide-field-xs",
            width: "30%",
            sortable: true
        },
        {
            label: "Form type",
            field: "formType",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "28%"
        },
        {
            label: "Date updated",
            type: "string",
            field(rowObj) {
                if (rowObj.updatedOn) {
                    return rowObj.updatedOn.substring(0, 10)
                }
            },
            thClass: "width-sm hide-field-md",
            tdClass: "hide-field-md",
            width: "20%"
        },
        {
            label: "Actions",
            field: "actions",
            thClass: "th-actions text-nowrap",
            tdClass: "td-actions text-nowrap",
            width: "8%",
            sortable: false
        }
    ],
    INVOICE_DETAIL_MODAL_COLUMNS: [
            {
                label: "Purchase order number",
                field: "poNumber",
                type: "string",
                thClass: "width-sm",
                tdClass: "align-left text-break",
                width: "15%",
                sortable: true
            },
            {
                label: "Request number",
                field: "requisitionNumber",
                type: "string",
                thClass: "width-sm hide-field-xs",
                tdClass: "align-left wrap-text hide-field-xs",
                width: "13%",
                sortable: true,
            },
            {
                label: "Requester name",
                type: "string",
                field: "requestedBy",
                thClass: "width-sm hide-field-xs",
                tdClass: "align-left wrap-text hide-field-xs",
                width: "14%",
                html: true
            },
            {
                label: "Net amount",
                field: "netValue",
                type: "string",
                thClass: "width-sm",
                tdClass: "align-left",
                width: "14%"
            },
            {
                label: "Remaining amount",
                field: "remainingValue",
                type: "string",
                thClass: "width-sm ",
                tdClass: "align-left",
                width: "14%"
            },
            {
                label: "Status",
                field: "status",
                type: "string",
                sortFn: (x, y) => { return VGT_COLUMNS.clearHTMLAndFilter(x,y) },
                thClass: "width-sm hide-field-md hide-field-xs",
                tdClass: "align-left hide-field-md table-data-ellipsis hide-field-xs",
                width: "14%",
                html: true
            },
            {
                label: "Purchase order date",
                field: "docDate",
                type: "string",
                thClass: "width-sm hide-field-md hide-field-xs",
                tdClass: "align-left hide-field-md table-data-ellipsis hide-field-xs",
                width: "12%"
            }
        ],
    COMPLETED_CASE_COLUMNS: [
        {
            label: "Case",
            field: "caseNumber",
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left",
            width: "15%"
        },
        {
            label: "Request type",
            field(rowObj) {
                if(rowObj.requestSubmissionType === EXCEPTION_SUBMISSION_CONSTANTS.EXIT_POINT)
                    return "Exception submission"
                return "Supplier engagement"
            },
            type: "string",
            thClass: "width-sm",
            tdClass: "align-left",
            width: "25%"
        },
        {
            label: "Case status",
            field: function(rowObj) {
                if(rowObj.status && rowObj.status === CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.RESOLVED_INCOMPLETE) {
                    return CONSTANTS.SERVICE_NOW_CASE_STATUS_MAP.CANCELLED_OVERRIDE
                }
                return rowObj.status
            },
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "20%"
        },
        {
            label: CONSTANTS.SUPPLIER_ONBOARDING_TRACKER.TITLE,
            field: "supplierOnBoardingStatus",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "18%"
        },
        {
            label: "Product description",
            field: "productDescription",
            type: "string",
            thClass: "width-sm hide-field-xs",
            tdClass: "align-left hide-field-xs",
            width: "24%"
        },
        {
            label: "Date added",
            type: "string",
            field(rowObj) {
                if(rowObj.createdOn){
                    return rowObj.createdOn.substring(0,10)
                }
            },
            thClass: "width-sm hide-field-xs",
            tdClass: "hide-date-responsive hide-field-xs",
            width: "15%"
        },
        {
            label: "Actions",
            field: "actions",
            thClass: "th-actions text-nowrap",
            tdClass: "td-actions text-nowrap",
            width: "22%",
            sortable: false
        }
    ],
    USER_INVOICE_SUBMISSION_COLUMNS: [
            {
                label: "Supplier name",
                field(rowObj) {
                    return rowObj.supplierNameContinued ? rowObj.supplierName + rowObj.supplierNameContinued : rowObj.supplierName
                },
                type: "string",
                thClass: "width-sm",
                tdClass: "align-left",
                width: "18%",
                sortable: true,
            },
            {
                label: "Supplier number",
                field: "supplierNumber",
                type: "string",
                thClass: "width-sm hide-field-md",
                tdClass: "hide-field-md",
                width: "10%",
                sortable: true
            },
            {
                label: "Company code",
                field: "companyCode",
                type: "string",
                thClass: "width-sm hide-field-md",
                tdClass: "hide-field-md",
                width: "8%",
                sortable: true
            },
            {
                label: "Attachment(s)",
                field: "attachedFileName",
                type: "string",
                thClass: "width-sm hide-field-md",
                tdClass: "hide-field-md",
                width: "15%",
                sortFn: (x, y) => {
                    return VGT_COLUMNS.sortAttachmentFileNames(x,y)
                },
                sortable: true
            },
            {
                label: "Invoice submission date & time (PST)",
                field: "formattedCreatedOn",
                type: "string",
                thClass: "width-sm hide-field-xs",
                tdClass: "align-left hide-field-xs",
                width: "20%",
                sortFn: (x, y) => {return x.localeCompare(y, 'en', { numeric: true })},
                sortable: true
            },
            {
                label: "Form type",
                field: "formType",
                type: "string",
                thClass: "width-sm hide-field-md",
                tdClass: "hide-field-md",
                width: "18%"
            },
            {
                label: "Status",
                field: "status",
                type: "string",
                thClass: "th-actions text-nowrap",
                tdClass: "td-actions text-nowrap",
                width: "11%"
            },
        ],
}


export default VGT_COLUMNS